// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-components-___UserDashboards__title___eWCm5 a {
  font-size: 0.5em;
  vertical-align: middle;
  margin-left: 1em;
}
.src-styles-components-___UserDashboards__dashboard___NyDtp {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/UserDashboards.less"],"names":[],"mappings":"AAAA;EAEI,gBAAA;EACA,sBAAA;EACA,gBAAA;AAAJ;AAIA;EACE,cAAA;AAFF","sourcesContent":[".title {\n  a {\n    font-size: 0.5em;\n    vertical-align: middle;\n    margin-left: 1em;\n  }\n}\n\n.dashboard {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export var title = `src-styles-components-___UserDashboards__title___eWCm5`;
export var dashboard = `src-styles-components-___UserDashboards__dashboard___NyDtp`;
export default ___CSS_LOADER_EXPORT___;
